import React from "react";
import uspa from "../../assets/images/uspa.webp";
import uspb from "../../assets/images/uspb.webp";
import uspc from "../../assets/images/uspc.webp";
import uspd from "../../assets/images/uspd.webp";
import CountUp from "react-countup";

const WhyChoose = () => {
  return (
    <>
      <section
        className="why_choose row_am"
        data-aos="fade-in"
        data-aos-duration={1500}
      >
        <div className="why_choose_inner">
          <div className="blure_shape bs_1"> </div>
          <div className="blure_shape bs_2"> </div>
          <div className="container">
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration={1500}
            >
              <span className="title_badge">Why choos us</span>
              <h2>Statistik Perusahaan</h2>
              <p>
                Perusahaan kami telah menunjukkan konsistensi yang kuat dalam
                mencapai hasil yang luar biasa. Statistik di bawah ini
                membuktikan dedikasi kami terhadap keunggulan dan inovasi.
              </p>
            </div>
            <div className="company_statistics">
              <ul
                className="app_statstic"
                id="counter"
                data-aos="fade-in"
                data-aos-duration={1500}
              >
                <li data-aos="fade-up" data-aos-duration={1500}>
                  <div className="text">
                    <div className="usp_img">
                      <img src={uspa} alt="image" />
                    </div>
                    <p>
                      <span className="counter-value" data-count={8000}>
                        <CountUp end={8000} start={0}></CountUp>
                      </span>
                      <span>+</span>
                    </p>
                    <p>Pelanggan Puas</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500}>
                  <div className="text">
                    <div className="usp_img">
                      <img src={uspb} alt="image" />
                    </div>
                    <p>
                      <span className="counter-value" data-count={10000}>
                        <CountUp end={10000} start={0}></CountUp>
                      </span>
                      <span>+</span>
                    </p>
                    <p>Logo Tercetak</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500}>
                  <div className="text">
                    <div className="usp_img">
                      <img src={uspc} alt="image" />
                    </div>
                    <p>
                      <span className="counter-value" data-count={42}>
                        <CountUp end={42} start={0}></CountUp>
                      </span>
                      <span>+</span>
                      <span>Thn</span>
                    </p>
                    <p>Pengalaman di industri</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500}>
                  <div className="text">
                    <div className="usp_img">
                      <img src={uspd} alt="image" />
                    </div>
                    <p>
                      <span className="counter-value" data-count={2500}>
                        <CountUp end={7000} start={0}></CountUp>
                      </span>
                      <span>+</span>
                    </p>
                    <p>Repeat Customer</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default WhyChoose;
